
    import '/mnt/src/components/Icon/index.md?watch=parent';
    export const demoIndex = {
  ids: ["icon-demo-comprehensivedemo","icon-demo-icon-list"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Icon/index.md?type=demo')
};